<template>
  <div>
    <TableFilters
      :filters="['shop', 'product', 'dateRange']"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :columns="columns"
      :export="[`salesexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="salesList"
              item-key="name"
              class="row-pointer"
              id="indextable10"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>

              <template v-slot:top>
                <tr>
                  <th>Product Name:</th>
                  <th>{{ filterDatas.productquery }}</th>
                  <th></th>
                  <th>Shop Name:</th>
                  <th>{{ filterDatas.shopquery }}</th>
                </tr>
              </template>

              <template v-slot:item.quantity="{ item }">{{
                item.quantity ? item.quantity : '.......'
              }}</template>

              <template v-slot:item.total="{ item }">{{
                item.sale.total ? item.sale.total : '.......'
              }}</template>
              <template v-slot:item.discount="{ item }">{{
                item.sale.discount_amount
                  ? item.sale.discount_amount
                  : '.......'
              }}</template>
              <template v-slot:item.grand_total="{ item }">{{
                item.sale.grand_total ? item.sale.grand_total : '.......'
              }}</template>

              <template v-slot:item.payment_status="{ item }">{{
                item.sale.payment_status ? item.sale.payment_status : '.......'
              }}</template>

              <template v-slot:item.shop="{ item }">{{
                item.sale.shop.name ? item.sale.shop.name : '.......'
              }}</template>

              <template v-slot:item.customer="{ item }">{{
                item.sale.customer.name ? item.sale.customer.name : '.......'
              }}</template>

              <template v-slot:item.biller="{ item }">{{
                item.sale.biller.first_name
                  ? item.sale.biller.first_name
                  : '.......'
              }}</template>
              <template
                slot="body.append"
                v-if="PurchaseList && PurchaseList.length > 0"
              >
                <tr class="black--text">
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ total | formatCurrency }}
                    </h3>
                  </th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ discount | formatCurrency }}
                    </h3>
                  </th>

                  <th>
                    <h3 class="justify-content-end">
                      {{ grandtotal | formatCurrency }}
                    </h3>
                  </th>
                  <th class="title"></th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
    <div class="d-flex justify-center align-center"></div>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  components: {
    TableFilters,
  },
  data() {
    return {
      hide: '',
      isLoading: true,
      errormsg: false,
      total: 0,
      grandTotal: 0,
      discountTotal: 0,
      columns: [
        {
          text: 'Number',
          value: 'no',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.no,
        },
        {
          text: 'Date',
          value: 'Date',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => moment(item?.sale.date).format('YYYY-MM-DD'),
        },
        {
          text: 'Shop',
          value: 'shop',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.shop.name,
        },

        {
          text: 'Customer',
          value: 'customer',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.customer.name,
        },

        {
          text: 'Biller',
          value: 'biller',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.biller.first_name,
        },
        {
          text: 'Quantity',
          value: 'quantity',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.quantity,
        },
        {
          text: 'Total',
          value: 'total',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.total,
        },
        {
          text: 'Discount',
          value: 'discount',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.discount_amount,
        },
        {
          text: 'Grand Total',
          value: 'grandtotal',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.grand_total,
        },

        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.sale.status,
        },
      ],
      salesList: [],

      shoperror: '',
      filter: {
        customer: '',
        biller: '',
        start: '',
        end: '',
        shop: '',
        saleType: '',
        product: '',
      },
    };
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    // sumField(array, filed) {
    //   let value = 0;
    //   array.forEach((element) => {
    //     value += parseFloat(element[filed]);
    //   });
    //   return value;
    // },

    generateReport(callBack = () => {}) {
      if (this.filter.shop && this.filter.product) {
        this.errormsg = false;
        var filter = this.filter;
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        this.$store
          .dispatch('report/getShopSalesReportProductManagement', filter)
          .then((res) => {
            if (res.data.data.length === 0) {
              this.salesList = [];
            } else {
              this.salesList = res.data.data[0].saleItems;
            }

            this.total = this.sumField(this.salesList, 'total');
            this.discount = this.sumField(this.salesList, 'discount_amount');
            this.grandtotal = this.sumField(this.salesList, 'grand_total');
            let i = 1;
            this.salesList.map((p) => {
              p.no = i;
              i++;
            });
            let saleAmount = {
              total: this.total,
              discount: this.discount,
              grandtotal: this.grandtotal,
            };
            setTimeout(() => {
              callBack();
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.salesList);
              // Update Pdf To List_Title
              this.$store.commit(
                'UPDATE_PDF_TITLE',
                'Sales Product Management Report',
              );
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
              this.$store.commit('UPDATE_SALE_TOTAL', saleAmount);
            }, 100);
          })
          .catch((err) => {
            this.shoperror = err.data;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);

            this.isLoading = false;
            this.messages = err.data.title;
          });
      } else if (this.filter.shop) {
        this.$confirm('Please Select the Product then Try?');
      } else if (this.filter.product) {
        this.$confirm('Please Select the Shop then Try?');
      } else {
        this.$confirm('Please Select the Shop and Product then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.salesList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseInt(element[filed]);
      });
      return value;
    },

    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.salesList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].quantity = Data[x].quantity;
          Data[x].total = Data[x].sale.total;
          Data[x].discount = Data[x].sale.discount_amount;
          Data[x].grandtotal = Data[x].sale.grand_total;
          Data[x].status = Data[x].sale.status;
          Data[x].shop = Data[x].sale.shop.name;
          Data[x].customer = Data[x].sale.customer.name;
          Data[x].biller = Data[x].sale.biller.first_name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Sales Product Management Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );
        doc.text(219, 11, `Total  :      `);
        doc.text(
          281,
          11,
          ` ${this.total.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        doc.text(219, 16, `Discount  :      `);
        doc.text(
          281,
          16,
          ` ${this.discount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        doc.text(219, 21, `Grand Total  :      `);
        doc.text(
          281,
          21,
          ` ${this.grandtotal.toLocaleString('en-US', {
            style: 'currency',
            currency: 'LKR',
          })}`,
          'right',
        );
        // doc.text(60, 10, `Total Amount :- ${this.total.toFixed(2)}`);
        // doc.text(100, 10, `Grand Total :- ${this.grandTotal.toFixed(2)}`);
        // doc.text(140, 10, `Discount Total :- ${this.discountTotal.toFixed(2)}`);
        // doc.text(180, 10, `Product :-${this.filterDatas.productquery}`);
        // doc.text(220, 10, `Shop:-${this.filterDatas.shopquery}`);
        doc.setFontSize(9);

        //let height;
        // if (
        //   (this.filterDatas.start == '' || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == '' || this.filterDatas.end == null)
        // ) {
        //   height = 20;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product            -     ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.shopquery
        //     ? doc.text(`Shop      -     ${this.filterDatas.shopquery}`, 15, 17)
        //     : null;
        // } else if (
        //   this.filterDatas.shopquery == '' ||
        //   this.filterDatas.shopquery == null
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(`Product  -    ${this.filterDatas.productquery}`, 15, 22)
        //     : null;
        //   height = 25;
        // } else if (
        //   this.filterDatas.productquery == '' ||
        //   this.filterDatas.productquery == null
        // ) {
        //   this.filterDatas.shopquery
        //     ? doc.text(`Shop      -     ${this.filterDatas.shopquery}`, 15, 22)
        //     : null;
        //   height = 25;
        // } else {
        //   height = 25;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product            -     ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.shopquery
        //     ? doc.text(`Shop      -     ${this.filterDatas.shopquery}`, 15, 17)
        //     : null;
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range     -     ${this.filterDatas.start +
        //           ' - ' +
        //           this.filterDatas.end}`,
        //         15,
        //         22
        //       )
        //     : null;
        // }

        const conditions = [
          { key: 'productquery', label: 'Product' },
          { key: 'shopquery', label: 'Shop' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }

          return acc;
        }, 15); // Initial

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Sales Report.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable10');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Sales Report.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

    ...mapState(['filterDatas']),
  },
};
</script>
